


































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringTransfusiSvc, {
  LaporanReaksiPayload
} from "@/services/MonitoringTransfusiService";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { appModule } from "@/store/modules/app";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import moment from "moment";

type SaranKey = "tanggal_crosstest" | "tanggal_darah_keluar" | "petugas_bdrs";

function kosong(): LaporanReaksiPayload {
  return {
    tanggal_crosstest: null,
    tanggal_darah_keluar: null,
    petugas_bdrs: null,
    petugas_pengambil_darah: null,
    dokter_dikonsulkan_user_id: null,
    tindakan_setelah_konsul: null
  };
}

@Component({
  components: { PersonAutoComplete, VCDateTimePicker }
})
export default class MonitoringTransfusiLaporanReaksi extends Vue {
  @Prop({ required: true }) monitoring!: any;

  form: LaporanReaksiPayload = kosong();
  saving = false;
  printing = false;
  dirty = false;
  hydrating = false;
  hydratedId: number | null = null;

  @Watch("monitoring", { immediate: true })
  onMonitoring(val: any) {
    if (!val) return;
    if (this.dirty && this.hydratedId === val.id) return;
    this.hydrate(val);
  }

  @Watch("form", { deep: true })
  onFormChange() {
    if (!this.hydrating) this.dirty = true;
  }

  hydrate(m: any) {
    this.hydrating = true;
    this.form = {
      tanggal_crosstest: m.tanggal_crosstest || null,
      tanggal_darah_keluar: m.tanggal_darah_keluar || null,
      petugas_bdrs: m.petugas_bdrs || null,
      petugas_pengambil_darah: m.petugas_pengambil_darah || null,
      dokter_dikonsulkan_user_id: m.dokter_dikonsulkan_user_id
        ? Number(m.dokter_dikonsulkan_user_id)
        : null,
      tindakan_setelah_konsul: m.tindakan_setelah_konsul || null
    };
    this.hydratedId = m.id;
    this.dirty = false;
    this.$nextTick(() => {
      this.hydrating = false;
    });
  }

  get saran(): Record<SaranKey, string | null> {
    return (
      (this.monitoring && this.monitoring.laporan_reaksi_saran) || {
        tanggal_crosstest: null,
        tanggal_darah_keluar: null,
        petugas_bdrs: null
      }
    );
  }

  get adaSaran(): boolean {
    return (["tanggal_crosstest", "tanggal_darah_keluar", "petugas_bdrs"] as SaranKey[]).some(
      k => !!this.saran[k] && !this.form[k]
    );
  }

  get lengkap(): boolean {
    const f = this.form;
    return (
      !!(f.tanggal_crosstest || this.saran.tanggal_crosstest) &&
      !!(f.tanggal_darah_keluar || this.saran.tanggal_darah_keluar) &&
      !!(f.petugas_bdrs || this.saran.petugas_bdrs) &&
      !!f.petugas_pengambil_darah &&
      !!f.dokter_dikonsulkan_user_id &&
      !!f.tindakan_setelah_konsul
    );
  }

  get tanggalCrosstestDate(): Date | null {
    return composeDate(this.form.tanggal_crosstest);
  }
  set tanggalCrosstestDate(val: Date | null) {
    this.form.tanggal_crosstest = toDateString(val);
  }

  get tanggalDarahKeluarDate(): Date | null {
    return composeDate(this.form.tanggal_darah_keluar);
  }
  set tanggalDarahKeluarDate(val: Date | null) {
    this.form.tanggal_darah_keluar = toDateString(val);
  }

  hintSaran(key: SaranKey, tanggal: boolean): string {
    const v = this.saran[key];
    if (!v || this.form[key]) return "";
    const tampil = tanggal ? moment(v, "YYYY-MM-DD").format("DD-MM-YYYY") : v;
    return `Saran dari data Bank Darah: ${tampil}`;
  }

  pakaiSaran() {
    (["tanggal_crosstest", "tanggal_darah_keluar", "petugas_bdrs"] as SaranKey[]).forEach(k => {
      if (!this.form[k] && this.saran[k]) {
        this.form[k] = this.saran[k];
      }
    });
  }

  async simpan() {
    if (!this.monitoring?.id) return;
    this.saving = true;
    try {
      const resp = await MonitoringTransfusiSvc.updateLaporanReaksi(
        this.monitoring.id,
        { ...this.form }
      );
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Data laporan reaksi disimpan");
        this.dirty = false;
        this.$emit("saved");
      }
    } catch {
      return;
    } finally {
      this.saving = false;
    }
  }

  async cetak() {
    if (!this.monitoring?.id) return;
    if (this.dirty && !confirm("Ada isian yang belum disimpan dan tidak akan ikut tercetak. Tetap cetak?")) {
      return;
    }
    this.printing = true;
    try {
      await MonitoringTransfusiSvc.openLaporanReaksiPdf(this.monitoring.id);
    } catch {
      return;
    } finally {
      this.printing = false;
    }
  }
}
